var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f1f1;}.b{fill:#7d8dd8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60 -255)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(60 255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,15.832V17.5C0,18.879,3.359,20,7.5,20S15,18.879,15,17.5V15.832C13.387,16.969,10.437,17.5,7.5,17.5S1.613,16.969,0,15.832ZM12.5,5C16.641,5,20,3.879,20,2.5S16.641,0,12.5,0,5,1.121,5,2.5,8.359,5,12.5,5ZM0,11.734V13.75c0,1.379,3.359,2.5,7.5,2.5s7.5-1.121,7.5-2.5V11.734c-1.613,1.328-4.566,2.016-7.5,2.016S1.613,13.062,0,11.734Zm16.25.43C18.488,11.73,20,10.926,20,10V8.332A9.593,9.593,0,0,1,16.25,9.68ZM7.5,6.25C3.359,6.25,0,7.648,0,9.375S3.359,12.5,7.5,12.5,15,11.1,15,9.375,11.641,6.25,7.5,6.25Zm8.566,2.2C18.41,8.027,20,7.2,20,6.25V4.582a12.717,12.717,0,0,1-6.277,1.633A4.374,4.374,0,0,1,16.066,8.449Z",
    transform: "translate(75 270)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuStaking);
export default __webpack_public_path__ + "static/media/icon-menu-staking.6f9c7a4b1e980ad0f7ef0419cb616238.svg";
export { ForwardRef as ReactComponent };